import gql from "graphql-tag";

export const GET_POST = gql`
    query GetPost($id: ID!) {
        post (id: $id) {
            id
            subject
            category
            message
            created
            imagesUrls
            documentsUrls
            author{
                id
                username
                profile {
                    id
                    displayName
                    profession
                    workplace
                }
            }
            tagSet{
                edges{
                    node{
                        id
                        name
                        usageCount
                    }
                }
            }
            commentSet{
                edges{
                    node{
                        id
                        message
                        created
                        author{
                            id
                            username
                            profile {
                                id
                                displayName
                                profession
                                workplace
                            }
                        }
                    }
                }
            }
        }
    }
`;